import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postManageableListItemSend = (params) => {
  return axiosClient
    .post("api/admin/manageable-list", params)
    .then((r) => r.data);
};
